<div class="td-wb-horizontal-toolbar" role="toolbar">
    <ng-content />
</div>

